import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	dateIcon: {
		height: 'auto',
		width: 16,
	},
});
